import { TAG_SETS } from "@/components/ui/tags/CommonTagChips";
import { TIME_ENTRY_TYPE_VALUES } from "@/lib/constants/time-entry-types";
import type { Time_Entry_Type } from "@/src/gql/graphql";

/**
 * Time entry status options
 */
export const TIME_ENTRY_STATUS_OPTIONS = [
  { label: "Pending", value: "pending" },
  { label: "Approved", value: "approved" },
  { label: "Rejected", value: "rejected" },
];

const TIME_ENTRY_TYPE_LABELS: Record<Time_Entry_Type, string> = {
  billable: "Billable",
  non_billable: "Non-Billable",
  travel: "Travel",
  research: "Research",
};

/** UI options — values from `TIME_ENTRY_TYPE_VALUES`. */
export const TIME_ENTRY_TYPE_OPTIONS = TIME_ENTRY_TYPE_VALUES.map((value) => ({
  label: TIME_ENTRY_TYPE_LABELS[value],
  value,
}));

/**
 * Sync status options
 */
export const SYNC_STATUS_OPTIONS = [
  { label: "Pending", value: "pending" },
  { label: "Synced", value: "synced" },
  { label: "Failed", value: "failed" },
  { label: "Disapproved", value: "disapproved" },
];

/**
 * Tag sets for time entry templates
 */
export const timeEntryTemplateTagSets = {
  TIME_ENTRY: TAG_SETS.TIME_ENTRY || [],
};
